module.exports = __webpack_public_path__ + "static/media/registration-bottom-blob-blue.ea7f8d1f.svg";